import React, { Component } from 'react';
import Formulario from './FormSeleccionarRegistro';


class SeleccionarPeriodo extends Component{

    componentDidMount = () => {
        const { periodosList } = this.props;
        periodosList();
    }
    render(){
        const { periodoL } = this.props;
        return(
           
            <Formulario
                periodoL={periodoL}
            />
           
        );
    } 
}

export default SeleccionarPeriodo;